module.exports = __webpack_public_path__ + "static/img/up2.eb2ec0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/up2.png
// module id = AFOt
// module chunks = 1